<template>
  <div class="box">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="3"><p class="label">Description</p></v-col>
          <v-col cols="3"><v-text-field :value="role.text" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Status</p></v-col>
          <v-col cols="3"><v-text-field :value="role.statusMessage" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-icon :style="cssStatusColor(role.statusColor)">mdi-square</v-icon></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">User status</p></v-col>
          <v-col cols="3"><v-text-field :value="role.userStatusMessage" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-icon :style="cssStatusColor(role.userStatusColor)">mdi-square</v-icon></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Profile</p></v-col>
          <v-col cols="3"><v-text-field :value="role.profile" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Created by / at</p></v-col>
          <v-col cols="3"><v-text-field :value="role.createUsr" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-text-field :value="role.createDatim | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3"><p class="label">Updated by / at</p></v-col>
          <v-col cols="3"><v-text-field :value="role.changeUsr" outlined dense hide-details readonly></v-text-field></v-col>
          <v-col cols="3"><v-text-field :value="role.changeDatim | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import share from './searchShare.js';
export default {
  props: {
    role: {
      type: Object,
    },
  },
  mixins: [share],
};
</script>

<style lang="scss" scoped>
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
